import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import SnackBarContent from '@material-ui/core/SnackbarContent';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { SUCCESS_COLOR } from '../general/constants/_colors';

const useStyles = makeStyles(() => ({
  button: {
    color: SUCCESS_COLOR,
  },
  snackBar: {
    minWidth: '60%',
  },
  snackBarContent: {
    width: '100%',
  },
}));

const VersionDetect = ({ isLatestVersion, onRefresh }) => {
  if (isLatestVersion) {
    return null;
  }

  const classes = useStyles();

  return (
    <Snackbar className={classes.snackBar} key="bottom center" open>
      <SnackBarContent
        className={classes.snackBarContent}
        message="New Version Detected"
        action={
          <Button onClick={onRefresh} className={classes.button}>
            RELOAD NOW
          </Button>
        }
      />
    </Snackbar>
  );
};

VersionDetect.propTypes = {
  isLatestVersion: PropTypes.bool.isRequired,
  onRefresh: PropTypes.func.isRequired,
};

export default VersionDetect;
